'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.roomingListsDataRequested = roomingListsDataRequested;
exports.roomingListsDataReceived = roomingListsDataReceived;
exports.roomingListsDataRequestFailed = roomingListsDataRequestFailed;
var ROOMING_LISTS_DATA_REQUESTED = exports.ROOMING_LISTS_DATA_REQUESTED = 'ROOMING_LISTS_DATA_REQUESTED';
var ROOMING_LISTS_DATA_RECEIVED = exports.ROOMING_LISTS_DATA_RECEIVED = 'ROOMING_LISTS_DATA_RECEIVED';
var ROOMING_LISTS_DATA_REQUEST_FAILED = exports.ROOMING_LISTS_DATA_REQUEST_FAILED = 'ROOMING_LISTS_DATA_REQUEST_FAILED';

function roomingListsDataRequested() {
    return { type: ROOMING_LISTS_DATA_REQUESTED };
}

function roomingListsDataReceived(roomingListData) {
    return { type: ROOMING_LISTS_DATA_RECEIVED, roomingListData: roomingListData };
}

function roomingListsDataRequestFailed(error) {
    return { type: ROOMING_LISTS_DATA_REQUEST_FAILED, error: error };
}


//////////////////
// WEBPACK FOOTER
// ./app/actions/roomingListsDataActions.js
// module id = 304
// module chunks = 0